function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};

// src/index.ts
import "@mapbox/search-js-web";
import { config } from "@mapbox/search-js-web";

// src/components/AddressAutofill.tsx
import React, { useRef, useEffect, useImperativeHandle } from "react";
var AddressAutofill = React.forwardRef(function (props, refProp) {
  var accessToken = props.accessToken,
    options = props.options,
    theme = props.theme,
    popoverOptions = props.popoverOptions,
    confirmOnBrowserAutofill = props.confirmOnBrowserAutofill,
    browserAutofillEnabled = props.browserAutofillEnabled,
    children = props.children,
    onChange = props.onChange,
    onSuggest = props.onSuggest,
    onSuggestError = props.onSuggestError,
    onRetrieve = props.onRetrieve,
    interceptSearch = props.interceptSearch;
  var ref = useRef();
  useImperativeHandle(refProp, function () {
    return {
      focus: function focus() {
        if (ref.current) return ref.current.focus();
        throw new Error("AddressAutofill is not mounted");
      }
    };
  });
  useEffect(function () {
    if (ref.current) ref.current.options = options;
  }, [ref.current, options]);
  useEffect(function () {
    if (ref.current) ref.current.interceptSearch = interceptSearch;
  }, [ref.current, options]);
  useEffect(function () {
    if (ref.current) ref.current.theme = theme;
  }, [ref.current, theme]);
  useEffect(function () {
    if (ref.current) ref.current.popoverOptions = popoverOptions;
  }, [ref.current, popoverOptions]);
  useEffect(function () {
    if (ref.current) ref.current.confirmOnBrowserAutofill = confirmOnBrowserAutofill;
  }, [ref.current, confirmOnBrowserAutofill]);
  useEffect(function () {
    if (ref.current) ref.current.browserAutofillEnabled = browserAutofillEnabled;
  }, [ref.current, browserAutofillEnabled]);
  useEffect(function () {
    var node = ref.current;
    if (!node) return;
    if (!onSuggest) return;
    var fn = function fn(e) {
      return onSuggest(e.detail);
    };
    node.addEventListener("suggest", fn);
    return function () {
      node.removeEventListener("suggest", fn);
    };
  }, [ref.current, onSuggest]);
  useEffect(function () {
    var node = ref.current;
    if (!node) return;
    if (!onSuggestError) return;
    var fn = function fn(e) {
      return onSuggestError(e.detail);
    };
    node.addEventListener("suggesterror", fn);
    return function () {
      node.removeEventListener("suggesterror", fn);
    };
  }, [ref.current, onSuggestError]);
  useEffect(function () {
    var node = ref.current;
    if (!node) return;
    if (!onRetrieve) return;
    var fn = function fn(e) {
      return onRetrieve(e.detail);
    };
    node.addEventListener("retrieve", fn);
    return function () {
      node.removeEventListener("retrieve", fn);
    };
  }, [ref.current, onRetrieve]);
  useEffect(function () {
    var node = ref.current;
    if (!node) return;
    if (!onChange) return;
    var fn = function fn(e) {
      if (e.target !== e.currentTarget) return;
      onChange(e.detail);
    };
    node.addEventListener("input", fn);
    return function () {
      node.removeEventListener("input", fn);
    };
  }, [ref.current, onChange]);
  useEffect(function () {
    if (ref.current) ref.current.accessToken = accessToken;
  }, [ref.current, accessToken]);
  return /* @__PURE__ */React.createElement("mapbox-address-autofill", {
    ref: ref
  }, children);
});

// src/components/SearchBox.tsx
import React2, { useRef as useRef2, useEffect as useEffect2, useImperativeHandle as useImperativeHandle2 } from "react";
var SearchBox = React2.forwardRef(function (props, refProp) {
  var accessToken = props.accessToken,
    options = props.options,
    theme = props.theme,
    popoverOptions = props.popoverOptions,
    placeholder = props.placeholder,
    map = props.map,
    marker = props.marker,
    mapboxgl = props.mapboxgl,
    value = props.value,
    onChange = props.onChange,
    onSuggest = props.onSuggest,
    onSuggestError = props.onSuggestError,
    onRetrieve = props.onRetrieve,
    onClear = props.onClear,
    interceptSearch = props.interceptSearch;
  var ref = useRef2();
  useImperativeHandle2(refProp, function () {
    return {
      focus: function focus() {
        if (ref.current) return ref.current.focus();
        throw new Error("SearchBox is not mounted");
      },
      search: function search(text) {
        if (ref.current) return ref.current.search(text);
        throw new Error("SearchBox is not mounted");
      }
    };
  });
  useEffect2(function () {
    if (ref.current) ref.current.options = options || {};
  }, [ref.current, options]);
  useEffect2(function () {
    if (ref.current) ref.current.interceptSearch = interceptSearch;
  }, [ref.current, interceptSearch]);
  useEffect2(function () {
    if (ref.current) ref.current.theme = theme;
  }, [ref.current, theme]);
  useEffect2(function () {
    if (ref.current) ref.current.popoverOptions = popoverOptions;
  }, [ref.current, popoverOptions]);
  useEffect2(function () {
    if (ref.current) ref.current.placeholder = placeholder;
  }, [ref.current, placeholder]);
  useEffect2(function () {
    if (ref.current) ref.current.value = value || "";
  }, [ref.current, value]);
  useEffect2(function () {
    var node = ref.current;
    if (!node) return;
    node.bindMap(map);
    return function () {
      node.unbindMap();
    };
  }, [ref.current, map]);
  useEffect2(function () {
    if (ref.current) ref.current.marker = marker;
  }, [ref.current, marker]);
  useEffect2(function () {
    if (ref.current) ref.current.mapboxgl = mapboxgl;
  }, [ref.current, mapboxgl]);
  useEffect2(function () {
    var node = ref.current;
    if (!node) return;
    if (!onSuggest) return;
    var fn = function fn(e) {
      return onSuggest(e.detail);
    };
    node.addEventListener("suggest", fn);
    return function () {
      node.removeEventListener("suggest", fn);
    };
  }, [ref.current, onSuggest]);
  useEffect2(function () {
    var node = ref.current;
    if (!node) return;
    if (!onSuggestError) return;
    var fn = function fn(e) {
      return onSuggestError(e.detail);
    };
    node.addEventListener("suggesterror", fn);
    return function () {
      node.removeEventListener("suggesterror", fn);
    };
  }, [ref.current, onSuggestError]);
  useEffect2(function () {
    var node = ref.current;
    if (!node) return;
    if (!onRetrieve) return;
    var fn = function fn(e) {
      return onRetrieve(e.detail);
    };
    node.addEventListener("retrieve", fn);
    return function () {
      node.removeEventListener("retrieve", fn);
    };
  }, [ref.current, onRetrieve]);
  useEffect2(function () {
    var node = ref.current;
    if (!node) return;
    if (!onChange) return;
    var fn = function fn(e) {
      if (e.target !== e.currentTarget) return;
      onChange(e.detail);
    };
    node.addEventListener("input", fn);
    return function () {
      node.removeEventListener("input", fn);
    };
  }, [ref.current, onChange]);
  useEffect2(function () {
    var node = ref.current;
    if (!node) return;
    if (!onClear) return;
    var fn = function fn() {
      onClear();
    };
    node.addEventListener("clear", fn);
    return function () {
      node.removeEventListener("clear", fn);
    };
  }, [ref.current, onClear]);
  useEffect2(function () {
    if (ref.current) ref.current.accessToken = accessToken;
  }, [ref.current, accessToken]);
  return /* @__PURE__ */React2.createElement("mapbox-search-box", {
    ref: ref
  });
});

// src/components/Geocoder.tsx
import React3, { useRef as useRef3, useEffect as useEffect3, useImperativeHandle as useImperativeHandle3 } from "react";
var Geocoder = React3.forwardRef(function (props, refProp) {
  var accessToken = props.accessToken,
    options = props.options,
    theme = props.theme,
    popoverOptions = props.popoverOptions,
    placeholder = props.placeholder,
    map = props.map,
    marker = props.marker,
    mapboxgl = props.mapboxgl,
    value = props.value,
    onChange = props.onChange,
    onSuggest = props.onSuggest,
    onSuggestError = props.onSuggestError,
    onRetrieve = props.onRetrieve,
    onClear = props.onClear,
    interceptSearch = props.interceptSearch;
  var ref = useRef3();
  useImperativeHandle3(refProp, function () {
    return {
      focus: function focus() {
        if (ref.current) return ref.current.focus();
        throw new Error("Geocoder is not mounted");
      },
      search: function search(text) {
        if (ref.current) return ref.current.search(text);
        throw new Error("Geocoder is not mounted");
      }
    };
  });
  useEffect3(function () {
    if (ref.current) ref.current.options = options || {};
  }, [ref.current, options]);
  useEffect3(function () {
    if (ref.current) ref.current.interceptSearch = interceptSearch;
  }, [ref.current, interceptSearch]);
  useEffect3(function () {
    if (ref.current) ref.current.theme = theme;
  }, [ref.current, theme]);
  useEffect3(function () {
    if (ref.current) ref.current.popoverOptions = popoverOptions;
  }, [ref.current, popoverOptions]);
  useEffect3(function () {
    if (ref.current) ref.current.placeholder = placeholder;
  }, [ref.current, placeholder]);
  useEffect3(function () {
    if (ref.current) ref.current.value = value || "";
  }, [ref.current, value]);
  useEffect3(function () {
    var node = ref.current;
    if (!node) return;
    node.bindMap(map);
    return function () {
      node.unbindMap();
    };
  }, [ref.current, map]);
  useEffect3(function () {
    if (ref.current) ref.current.marker = marker;
  }, [ref.current, marker]);
  useEffect3(function () {
    if (ref.current) ref.current.mapboxgl = mapboxgl;
  }, [ref.current, mapboxgl]);
  useEffect3(function () {
    var node = ref.current;
    if (!node) return;
    if (!onSuggest) return;
    var fn = function fn(e) {
      return onSuggest(e.detail);
    };
    node.addEventListener("suggest", fn);
    return function () {
      node.removeEventListener("suggest", fn);
    };
  }, [ref.current, onSuggest]);
  useEffect3(function () {
    var node = ref.current;
    if (!node) return;
    if (!onSuggestError) return;
    var fn = function fn(e) {
      return onSuggestError(e.detail);
    };
    node.addEventListener("suggesterror", fn);
    return function () {
      node.removeEventListener("suggesterror", fn);
    };
  }, [ref.current, onSuggestError]);
  useEffect3(function () {
    var node = ref.current;
    if (!node) return;
    if (!onRetrieve) return;
    var fn = function fn(e) {
      return onRetrieve(e.detail);
    };
    node.addEventListener("retrieve", fn);
    return function () {
      node.removeEventListener("retrieve", fn);
    };
  }, [ref.current, onRetrieve]);
  useEffect3(function () {
    var node = ref.current;
    if (!node) return;
    if (!onChange) return;
    var fn = function fn(e) {
      if (e.target !== e.currentTarget) return;
      onChange(e.detail);
    };
    node.addEventListener("input", fn);
    return function () {
      node.removeEventListener("input", fn);
    };
  }, [ref.current, onChange]);
  useEffect3(function () {
    var node = ref.current;
    if (!node) return;
    if (!onClear) return;
    var fn = function fn() {
      onClear();
    };
    node.addEventListener("clear", fn);
    return function () {
      node.removeEventListener("clear", fn);
    };
  }, [ref.current, onClear]);
  useEffect3(function () {
    if (ref.current) ref.current.accessToken = accessToken;
  }, [ref.current, accessToken]);
  return /* @__PURE__ */React3.createElement("mapbox-geocoder", {
    ref: ref
  });
});

// src/components/AddressMinimap.tsx
import React4, { useRef as useRef4, useEffect as useEffect4 } from "react";
function AddressMinimap(props) {
  var _props$canAdjustMarke = props.canAdjustMarker,
    canAdjustMarker = _props$canAdjustMarke === void 0 ? false : _props$canAdjustMarke,
    _props$keepMarkerCent = props.keepMarkerCentered,
    keepMarkerCentered = _props$keepMarkerCent === void 0 ? false : _props$keepMarkerCent,
    _props$markerAnchor = props.markerAnchor,
    markerAnchor = _props$markerAnchor === void 0 ? "bottom" : _props$markerAnchor,
    onSaveMarkerLocation = props.onSaveMarkerLocation,
    _props$show = props.show,
    show = _props$show === void 0 ? false : _props$show,
    accessToken = props.accessToken,
    _props$feature = props.feature,
    feature = _props$feature === void 0 ? null : _props$feature,
    adjustBtnText = props.adjustBtnText,
    saveBtnText = props.saveBtnText,
    cancelBtnText = props.cancelBtnText,
    _props$satelliteToggl = props.satelliteToggle,
    satelliteToggle = _props$satelliteToggl === void 0 ? false : _props$satelliteToggl,
    theme = props.theme,
    _props$mapStyleMode = props.mapStyleMode,
    mapStyleMode = _props$mapStyleMode === void 0 ? "default" : _props$mapStyleMode,
    _props$defaultMapStyl = props.defaultMapStyle,
    defaultMapStyle = _props$defaultMapStyl === void 0 ? ["mapbox", "streets-v11"] : _props$defaultMapStyl,
    footer = props.footer;
  var ref = useRef4();
  useEffect4(function () {
    if (!ref.current) return;
    if (show) {
      ref.current.show();
    } else {
      ref.current.hide();
    }
  }, [ref.current, show]);
  useEffect4(function () {
    if (ref.current) ref.current.theme = theme;
  }, [ref.current, theme]);
  useEffect4(function () {
    if (ref.current) ref.current.feature = show ? feature : null;
  }, [ref.current, feature, show]);
  useEffect4(function () {
    if (ref.current) ref.current.mapStyleMode = mapStyleMode;
  }, [ref.current, mapStyleMode]);
  useEffect4(function () {
    if (adjustBtnText === void 0) return;
    if (ref.current) ref.current.adjustBtnText = adjustBtnText;
  }, [ref.current, adjustBtnText]);
  useEffect4(function () {
    if (saveBtnText === void 0) return;
    if (ref.current) ref.current.saveBtnText = saveBtnText;
  }, [ref.current, saveBtnText]);
  useEffect4(function () {
    if (cancelBtnText === void 0) return;
    if (ref.current) ref.current.cancelBtnText = cancelBtnText;
  }, [ref.current, cancelBtnText]);
  useEffect4(function () {
    if (ref.current) ref.current.defaultMapStyle = defaultMapStyle;
  }, [ref.current, defaultMapStyle]);
  useEffect4(function () {
    if (footer === void 0) return;
    if (ref.current) ref.current.footer = footer;
  }, [ref.current, footer]);
  useEffect4(function () {
    if (ref.current) ref.current.accessToken = accessToken;
  }, [ref.current, accessToken]);
  useEffect4(function () {
    if (ref.current) ref.current.onSaveMarkerLocation = onSaveMarkerLocation;
  }, [ref.current, onSaveMarkerLocation]);
  return /* @__PURE__ */React4.createElement("mapbox-address-minimap", {
    ref: ref,
    "can-adjust-marker": canAdjustMarker,
    "keep-marker-centered": keepMarkerCentered,
    "marker-anchor": markerAnchor,
    "satellite-toggle": satelliteToggle
  });
}

// src/hooks/useEvented.tsx
import { useEffect as useEffect5, useRef as useRef5 } from "react";
function useEvented(evented, eventName, cb) {
  var cbRef = useRef5(cb);
  useEffect5(function () {
    cbRef.current = cb;
  });
  useEffect5(function () {
    if (!evented) return;
    var fn = function fn(object) {
      return cbRef.current(object);
    };
    evented.addEventListener(eventName, fn);
    return function () {
      evented.removeEventListener(eventName, fn);
    };
  }, [evented, eventName, cbRef]);
}

// src/hooks/useAddressAutofillCore.tsx
import { useEffect as useEffect6, useMemo } from "react";
import { AddressAutofillCore } from "@mapbox/search-js-core";
var DEFAULTS = AddressAutofillCore.defaults;
function useAddressAutofillCore(options) {
  var autofill = useMemo(function () {
    return new AddressAutofillCore();
  }, []);
  useEffect6(function () {
    var _a = options,
      accessToken = _a.accessToken,
      restOptions = __objRest(_a, ["accessToken"]);
    autofill.accessToken = accessToken;
    autofill.defaults = __spreadValues(__spreadValues({}, DEFAULTS), restOptions);
  }, [options]);
  return autofill;
}

// src/hooks/useSearchBoxCore.tsx
import { useEffect as useEffect7, useMemo as useMemo2 } from "react";
import { SearchBoxCore } from "@mapbox/search-js-core";
var DEFAULTS2 = SearchBoxCore.defaults;
function useSearchBoxCore(options) {
  var search = useMemo2(function () {
    return new SearchBoxCore();
  }, []);
  useEffect7(function () {
    var _a = options,
      accessToken = _a.accessToken,
      restOptions = __objRest(_a, ["accessToken"]);
    search.accessToken = accessToken;
    search.defaults = __spreadValues(__spreadValues({}, DEFAULTS2), restOptions);
  }, [options]);
  return search;
}

// src/hooks/useGeocodingCore.tsx
import { useEffect as useEffect8, useMemo as useMemo3 } from "react";
import { GeocodingCore } from "@mapbox/search-js-core";
function useGeocodingCore(options) {
  var search = useMemo3(function () {
    return new GeocodingCore();
  }, []);
  useEffect8(function () {
    var _a = options,
      accessToken = _a.accessToken,
      restOptions = __objRest(_a, ["accessToken"]);
    search.accessToken = accessToken;
    search.defaults = __spreadValues({}, restOptions);
  }, [options]);
  return search;
}

// src/hooks/useSearchSession.tsx
import { SearchBoxCore as SearchBoxCore2, GeocodingCore as GeocodingCore2, SearchSession } from "@mapbox/search-js-core";
import { useMemo as useMemo4 } from "react";
function useSearchSession(search) {
  var searchSession = useMemo4(function () {
    return new SearchSession(search);
  }, [search]);
  if (search instanceof SearchBoxCore2) {
    return searchSession;
  } else if (search instanceof GeocodingCore2) {
    return searchSession;
  } else {
    return searchSession;
  }
}

// src/hooks/useConfirmAddress.tsx
import { useMemo as useMemo5, useRef as useRef6 } from "react";
import { confirmAddress } from "@mapbox/search-js-web";
function useConfirmAddress() {
  var optionsArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formRef = useRef6(null);
  return useMemo5(function () {
    return {
      formRef: formRef,
      showConfirm: function showConfirm() {
        return confirmAddress(formRef.current, optionsArg);
      }
    };
  }, [formRef, optionsArg]);
}
export { AddressAutofill, AddressMinimap, Geocoder, SearchBox, config, useAddressAutofillCore, useConfirmAddress, useEvented, useGeocodingCore, useAddressAutofillCore as useMapboxAutofill, useSearchBoxCore, useSearchSession };